import React, { useEffect, useState, useRef } from "react";
import { render } from "react-dom";
import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../ui/AnimatedProgressProvider";


export default function CatalogLoader({ progress, isLoading }) {
  const [computedPercentage, setComputedPercentage] = useState(0);
  const [visiblePaths, setVisiblePaths] = useState(0);
  const [visible, setVisible] = useState(true);

  // useEffect(() => {
  //   if (progress) {
  //     setComputedPercentage(progress.time);
  //   }
  // }, [progress]);

  useEffect(() => {
    if (!isLoading && computedPercentage === 100) {
      // setVisible(false);
    }
  }, [isLoading, computedPercentage]);

  // useEffect(() => {
  //   let interval;
  //   if (isLoading) {
  //     interval = setInterval(() => {
  //       setVisiblePaths(prev => (prev + 1) % (svgPaths.length + 1)); // Loop
  //     }, 300); // Change speed here
  //   }
  //   return () => clearInterval(interval);
  // }, [isLoading]);

  const svgPaths = [
    {
      d: `M30.0078 32.6297C31.7086 32.0776 33.5241 31.8872 35.2441 31.4113C37.2507 30.8592 39.2382 30.1929 41.2066 29.5837C40.1555 32.4964 37.7285 34.2859 34.7281 35.371C31.785 36.4371 28.7465 37.2367 25.4977 38.2456C25.9372 35.3139 27.447 33.4864 30.0269 32.6297M45.2007 0.78053C45.7741 4.51181 42.8501 4.72123 41.0728 6.47264C41.2639 3.50285 43.7483 2.85559 45.1434 0.818612C43.3852 1.54202 41.4932 2.5129 39.4866 3.75032C39.6395 10.4514 37.3462 16.4862 32.7024 21.8356C30.9824 23.8155 29.2242 25.7953 27.6189 27.8894C24.2555 32.287 22.6502 37.1034 23.2235 42.7384C24.2364 42.9478 25.2683 43.2905 26.3576 43.7283C26.8545 41.8056 28.4024 40.1113 30.8868 38.9881C32.7023 38.1695 34.5752 37.5222 36.4098 36.7417C37.9769 36.0754 39.5248 35.3329 41.111 34.5714C41.2448 31.9824 41.4359 29.2982 41.6844 26.5949C37.4036 29.9073 32.301 28.4415 27.81 29.4314C31.3837 24.577 36.5818 26.0999 41.7608 25.7953C41.8563 24.8625 41.9519 23.9487 42.0474 23.0159C39.3146 23.8155 36.2951 22.559 33.2757 22.8255C36.0658 19.4369 39.2 20.3698 42.2959 20.9028C42.4105 20.0842 42.5061 19.2656 42.6399 18.447C42.5444 18.447 42.4488 18.447 42.3341 18.428C40.5951 18.1805 38.8369 18.0282 36.9641 17.8188C38.6649 15.7056 40.8435 15.896 43.0221 16.0102C43.1559 15.2488 43.2705 14.5063 43.4234 13.7448C42.1621 13.9542 40.7861 13.9542 39.6013 14.4492C40.2893 12.7359 40.4422 12.3741 43.8821 11.4604C44.0732 10.5847 44.2643 9.728 44.4554 8.89037C43.2323 9.51859 41.7035 9.84223 40.4804 10.737C41.1302 7.78622 43.2514 7.13893 45.2007 6.07285C45.8505 3.84551 46.5767 1.78949 47.3984 0C46.7105 0.190371 45.9652 0.456909 45.2007 0.761503
      M21.7517 42.472C21.637 41.5772 21.6944 40.6635 21.6753 39.8258C21.5415 34.1718 24.1788 29.6219 27.6951 25.4528C29.8928 22.8637 32.1861 20.3318 34.1163 17.5523C36.9829 13.4213 38.3397 9.00469 38.4353 4.39771C37.4797 5.02593 36.5051 5.69223 35.5114 6.41564C36.2949 7.65305 36.83 9.04274 36.2758 10.8893C35.5305 9.74712 34.5749 8.73817 33.8487 7.6721C33.2945 8.09091 32.7403 8.5478 32.1861 9.00469C33.4665 10.8132 34.7851 12.6789 34.0016 15.4583C32.855 13.7069 31.2879 12.222 30.4088 10.5086C29.7972 11.0416 29.2048 11.5747 28.6124 12.1268C30.1221 14.2589 31.7466 16.3149 30.7337 19.4751C29.1857 17.7047 27.3893 16.1055 26.5293 14.1257C25.7076 14.9443 24.8858 15.7819 24.0832 16.6576C24.7712 17.8569 25.4401 19.0753 26.0898 20.3128C27.1791 22.3688 26.6631 24.2725 25.268 25.9096C24.1214 24.025 23.0703 22.2165 21.9428 20.446C21.7708 20.1795 21.6179 19.8939 21.4842 19.6274C20.6242 20.6364 19.8024 21.6644 18.9997 22.7304C19.4011 23.6062 19.7833 24.4628 20.1655 25.3386C21.3695 28.0038 22.0192 30.7261 20.7388 33.5055C19.7833 32.0967 18.9615 30.688 17.9487 29.4125C17.1651 28.4226 16.6683 27.4136 16.3625 26.4046C15.6745 27.4326 15.0057 28.4606 14.375 29.5077C15.0821 30.5928 15.8274 31.7731 16.6874 32.8582C18.8278 35.6376 19.9362 38.9311 19.8024 42.4149C20.4522 42.4149 21.1019 42.4529 21.7708 42.5291
      M12.2535 33.2197C9.82642 37.9219 8.06827 42.8525 7.26562 47.8402C10.8584 44.9276 14.5086 42.7573 18.6747 42.3956C15.5596 39.6543 12.7886 36.7987 12.2344 33.2007
      M40.9956 36.3608C39.8681 39.3877 37.7086 41.577 34.4024 42.7954C32.5105 43.4998 30.6185 44.1851 28.7266 44.8514C32.5487 46.9264 36.8486 50.3912 41.8174 55.7216C41.0147 54.389 40.5752 46.2982 40.9765 36.3418
      `,
      fill: '#00AC7D'
    },
    {
      d: 'M6.71094 53.5706C9.76864 52.238 12.4633 51.7049 14.9285 51.7049C20.528 51.7049 24.8087 54.5034 28.7646 57.0925C33.7143 60.3288 38.4155 63.4128 45.1042 60.976C41.3203 60.1575 37.9759 57.359 34.4787 54.4273C27.1593 48.2783 19.5915 41.9389 6.71094 53.5515',
      fill: '#00ADEE'
    },
    {
      d: 'M18.5795 63.9265C28.1731 69.0475 35.6262 71.3891 42.7163 71.5604C49.9783 71.7317 54.2018 67.3722 56.0364 64.8403C54.8898 65.4875 53.208 66.249 51.0294 66.782C47.0735 67.7529 40.6524 68.0385 32.6068 64.0217C31.1735 63.2983 29.8357 62.632 28.6126 62.0228C18.6369 57.016 14.8721 55.1123 11.1073 55.1123C10.4385 55.1123 9.78864 55.1694 9.08155 55.2836C3.88346 56.1213 1.39909 58.3486 0.195119 63.2411C-0.645749 66.6869 1.36088 69.6186 3.7306 71.0083C5.87099 72.2457 9.1198 72.6836 11.7953 70.1707C12.8082 69.2188 13.1521 67.9243 12.6935 66.8011C12.2539 65.7731 11.2411 65.1258 9.88422 65.0116C10.2091 66.4584 9.6931 67.258 9.33 67.6387C8.71846 68.2479 7.80119 68.4383 6.9221 68.1337C5.87101 67.772 5.14481 66.7821 5.01104 65.4875C4.85815 64.0598 5.39323 62.8604 6.53986 62.0799C8.96691 60.4617 13.3433 61.128 18.5605 63.9075',
      fill: '#0071BB'
    },
  ];

  if (!visible) return null;

  return (
    <div>
      <div className="overlay">     
        <div className='loader-container-catalog'>
          <svg viewBox='-10 0 75 75' fill='none' xmlns='http://www.w3.org/2000/svg'>
            {svgPaths.map((path, idx) => (
              <g key={idx}>
                <path
                  d={path.d}
                  fill="none"
                  stroke={path.fill}
                  strokeWidth="1.5"
                  style={{
                    strokeDasharray: 1000,
                    strokeDashoffset: 1000,
                    animation: `draw 0.8s ease forwards`,
                    animationDelay: `${idx * 0.3}s`,
                  }}
                />
                <path
                  d={path.d}
                  fill={path.fill}
                  opacity={0}
                  style={{
                    animation: `fadeIn 0.4s ease forwards`,
                    animationDelay: `${idx * 0.3 + 0.8}s`,
                  }}
                />
              </g>
            ))}
          </svg>
          <p className="loader-step" style={{color:`#FFF`}}>{progress?.step || "Fetching data from DB..."}</p>
        </div>
      </div>
    </div>
  )
}